<script setup>
import { ref, computed, onMounted } from 'vue';
import AdditionalPage from '@/components/clients/additionalPage/AdditionalPage.vue';
import { useEventStore } from '@/stores/event/event.store';
import { useRoute } from 'vue-router';

const eventStore = useEventStore();
const route = useRoute();

const pageId = ref(0);

const mainColor = computed(() => {
  return eventStore.getAdditionalSites().common[pageId.value].mainColor
    ? eventStore.getAdditionalSites().common[pageId.value].mainColor
    : eventStore.getColors.mainColor;
});
const backgroundColor = computed(() => {
  return eventStore.getAdditionalSites().common[pageId.value].backgroundColor
    ? eventStore.getAdditionalSites().common[pageId.value].backgroundColor
    : eventStore.getColors.backgroundColor;
});

onMounted(() => {
  pageId.value = route.params.page;
});
</script>

<template>
  <AdditionalPage
    :id="pageId"
    :main-color="mainColor"
    :background-color="backgroundColor"
  />
</template>
